import {api} from '@/api/factory';

class AdTag {
    constructor() {}

    getDefaultSettings() {
        return api.get('/v1/ad-tag-groups/default')
    }

    saveDefaultSettings(data) {
        return api({
            url: `/v1/ad-tag-groups/default`,
            method: 'PUT',
            data: data
        })
    }

    getGroups() {
        return api.get('/v1/ad-tag-groups')
    }

    createGroup(data) {
        return api({
            url: `/v1/ad-tag-groups`,
            method: 'POST',
            data: data
        })
    }

    updateGroup(group_id, data) {
        return api({
            url: `/v1/ad-tag-groups/${group_id}`,
            method: 'PUT',
            data: data
        })
    }

    deleteGroup(group_id) {
        return api({
            url: `/v1/ad-tag-groups/${group_id}`,
            method: 'DELETE'
        })
    }

    createDomain(group_id, data) {
        return api({
            url: `/v1/ad-tag-groups/${group_id}/domains`,
            method: 'POST',
            data: data
        })
    }

    updateDomain(group_id, domain_id, data) {
        return api({
            url: `/v1/ad-tag-groups/${group_id}/domains/${domain_id}`,
            method: 'PUT',
            data: data
        })
    }

    deleteDomain(group_id, domain_id) {
        return api({
            url: `/v1/ad-tag-groups/${group_id}/domains/${domain_id}`,
            method: 'DELETE'
        })
    }

    /**
     * Пагинированный список доменов группы.
     * Никогда не отдаёт все домены сразу — их может быть 100 000.
     */
    getDomains(group_id, params = {}) {
        return api({
            url: `/v1/ad-tag-groups/${group_id}/domains`,
            method: 'GET',
            params: params
        })
    }

    /**
     * Пакетное добавление доменов (до 5000 за запрос).
     * dry_run = true — предпросмотр без записи.
     */
    batchDomains(group_id, data) {
        return api({
            url: `/v1/ad-tag-groups/${group_id}/domains/batch`,
            method: 'POST',
            data: data
        })
    }

    batchDeleteDomains(group_id, ids) {
        return api({
            url: `/v1/ad-tag-groups/${group_id}/domains/batch-delete`,
            method: 'POST',
            data: { ids: ids }
        })
    }
}

export default AdTag;